module.exports = __webpack_public_path__ + "img/night.be5030ca.webp";